var xspList = [
  {
    id: 1,
    name:'热食类食品制售'
  },
  {
    id: 2,
    name:'冷食类食品制售'
  },
  {
    id: 3,
    name:'糕点类食品制售（不含裱花糕点）'
  },
  {
    id: 4,
    name:'自制饮品制售（不含自酿酒及自制生鲜乳饮品）'
  },
  {
    id: 5,
    name:'预包装食品销售（含冷藏冷冻食品）'
  },
  {
    id: 6,
    name:'预包装食品销售（不含冷藏冷冻食品）'
  },
  {
    id: 7,
    name:'散装食品销售（含冷藏冷冻食品）'
  },
  {
    id: 8,
    name:'散装食品销售（不含冷藏冷冻食品）'
  }
]

export default xspList